/**
 * Generated by orval v8.4.0 🍺
 * Do not edit manually.
 * Medme Marketing PRM API
 * API для автоматизированных маркетинговых рассылок и выгрузок (MedMe PRM).

**Разделы продукта:**
- **Рассылки** — отправка сообщений по сегменту (разово или по расписанию)
- **Выгрузки** — таблица пациентов по сегменту (файл, опционально e-mail с архивом)
- **Отчётность** — журнал запусков и доставки

**Авторизация:** HttpOnly cookie `token` (JWT), как в stats-api. Получение токена — через `GET /auth` stats-api.

**Контекст организации:** API работает с понятием «организация» — всем списком бизнесов, к которым у пользователя есть доступ. Сервер резолвит бизнесы автоматически из JWT-токена; `businessId` в query-параметрах не передаётся. Для операций над конкретным бизнесом (создание задачи, принятие условий) `businessId` передаётся в теле запроса.

 * OpenAPI spec version: 1.0.0
 */
import { faker } from "@faker-js/faker"
import type { RequestHandlerOptions } from "msw"
import { delay, HttpResponse, http } from "msw"

import type {
	MarketingContextResponse,
	MarketingTimezonesResponse,
} from ".././types/marketing"

export const getGetMarketingContextResponseMock = (
	overrideResponse: Partial<Extract<MarketingContextResponse, object>> = {},
): MarketingContextResponse => ({
	marketingEnabled: faker.datatype.boolean(),
	marketingAccepted: faker.helpers.arrayElement([
		faker.datatype.boolean(),
		undefined,
	]),
	marketingSmsBalance: faker.number.int(),
	sendLimit: 5000,
	defaultTimezone: "Europe/Moscow",
	...overrideResponse,
})

export const getAcceptMarketingTermsResponseMock = (
	overrideResponse: Partial<Extract<MarketingContextResponse, object>> = {},
): MarketingContextResponse => ({
	marketingEnabled: faker.datatype.boolean(),
	marketingAccepted: faker.helpers.arrayElement([
		faker.datatype.boolean(),
		undefined,
	]),
	marketingSmsBalance: faker.number.int(),
	sendLimit: 5000,
	defaultTimezone: "Europe/Moscow",
	...overrideResponse,
})

export const getGetMarketingTimezonesResponseMock = (
	overrideResponse: Partial<Extract<MarketingTimezonesResponse, object>> = {},
): MarketingTimezonesResponse => ({
	timezones: Array.from(
		{ length: faker.number.int({ min: 1, max: 5 }) },
		(_, i) => i + 1,
	).map(() => ({
		id: "Europe/Moscow",
		label: "Москва · UTC+3 — пояс бизнеса",
		offset: "UTC+3",
		isBusinessDefault: faker.helpers.arrayElement([
			faker.datatype.boolean(),
			undefined,
		]),
	})),
	...overrideResponse,
})

export const getGetMarketingContextMockHandler = (
	overrideResponse?:
		| MarketingContextResponse
		| ((
				info: Parameters<Parameters<typeof http.get>[1]>[0],
		  ) => Promise<MarketingContextResponse> | MarketingContextResponse),
	options?: RequestHandlerOptions,
) => {
	return http.get(
		"*/marketing/context",
		async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {
			await delay(300)

			return HttpResponse.json(
				overrideResponse !== undefined
					? typeof overrideResponse === "function"
						? await overrideResponse(info)
						: overrideResponse
					: getGetMarketingContextResponseMock(),
				{ status: 200 },
			)
		},
		options,
	)
}

export const getAcceptMarketingTermsMockHandler = (
	overrideResponse?:
		| MarketingContextResponse
		| ((
				info: Parameters<Parameters<typeof http.post>[1]>[0],
		  ) => Promise<MarketingContextResponse> | MarketingContextResponse),
	options?: RequestHandlerOptions,
) => {
	return http.post(
		"*/marketing/context/accept-terms",
		async (info: Parameters<Parameters<typeof http.post>[1]>[0]) => {
			await delay(300)

			return HttpResponse.json(
				overrideResponse !== undefined
					? typeof overrideResponse === "function"
						? await overrideResponse(info)
						: overrideResponse
					: getAcceptMarketingTermsResponseMock(),
				{ status: 200 },
			)
		},
		options,
	)
}

export const getGetMarketingTimezonesMockHandler = (
	overrideResponse?:
		| MarketingTimezonesResponse
		| ((
				info: Parameters<Parameters<typeof http.get>[1]>[0],
		  ) => Promise<MarketingTimezonesResponse> | MarketingTimezonesResponse),
	options?: RequestHandlerOptions,
) => {
	return http.get(
		"*/marketing/timezones",
		async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {
			await delay(300)

			return HttpResponse.json(
				overrideResponse !== undefined
					? typeof overrideResponse === "function"
						? await overrideResponse(info)
						: overrideResponse
					: getGetMarketingTimezonesResponseMock(),
				{ status: 200 },
			)
		},
		options,
	)
}
export const getMarketingContextMock = () => [
	getGetMarketingContextMockHandler(),
	getAcceptMarketingTermsMockHandler(),
	getGetMarketingTimezonesMockHandler(),
]
